import {
  easeBack,
  easeBackIn,
  easeBackInOut,
  easeBackOut,
  easeBounce,
  easeBounceIn,
  easeBounceInOut,
  easeBounceOut,
  easeCircle,
  easeCircleIn,
  easeCircleInOut,
  easeCircleOut,
  easeCubic,
  easeCubicIn,
  easeCubicInOut,
  easeCubicOut,
  easeElastic,
  easeElasticIn,
  easeElasticInOut,
  easeElasticOut,
  easeExp,
  easeExpIn,
  easeExpInOut,
  easeExpOut,
  easeLinear,
  easePolyIn,
  easePolyInOut,
  easePolyOut,
  easeQuad,
  easeQuadIn,
  easeQuadInOut,
  easeQuadOut,
  easeSin,
  easeSinIn,
  easeSinInOut,
  easeSinOut,
} from 'd3-ease'

import { LightCarouselSettings } from './types'

export function mapEasingToFunction(
  easing: LightCarouselSettings['transitionEasing']
) {
  switch (easing) {
    case 'easeLinear':
      return easeLinear

    case 'easeQuadIn':
      return easeQuadIn

    case 'easeQuadOut':
      return easeQuadOut

    case 'easeQuad':
      return easeQuad

    case 'easeQuadInOut':
      return easeQuadInOut

    case 'easeCubicIn':
      return easeCubicIn

    case 'easeCubicOut':
      return easeCubicOut

    case 'easeCubic':
      return easeCubic

    case 'easeCubicInOut':
      return easeCubicInOut

    case 'easePolyIn':
      return easePolyIn

    case 'easePolyOut':
      return easePolyOut

    case 'easePolyInOut':
      return easePolyInOut

    case 'easeExpIn':
      return easeExpIn

    case 'easeExpOut':
      return easeExpOut

    case 'easeExp':
      return easeExp

    case 'easeExpInOut':
      return easeExpInOut

    case 'easeSinIn':
      return easeSinIn

    case 'easeSinOut':
      return easeSinOut

    case 'easeSin':
      return easeSin

    case 'easeSinInOut':
      return easeSinInOut

    case 'easeCircleIn':
      return easeCircleIn

    case 'easeCircleOut':
      return easeCircleOut

    case 'easeCircle':
      return easeCircle

    case 'easeCircleInOut':
      return easeCircleInOut

    case 'easeElasticIn':
      return easeElasticIn

    case 'easeElastic':
      return easeElastic

    case 'easeElasticOut':
      return easeElasticOut

    case 'easeElasticInOut':
      return easeElasticInOut

    case 'easeBackIn':
      return easeBackIn

    case 'easeBackOut':
      return easeBackOut

    case 'easeBack':
      return easeBack

    case 'easeBackInOut':
      return easeBackInOut

    case 'easeBounceIn':
      return easeBounceIn

    case 'easeBounce':
      return easeBounce

    case 'easeBounceOut':
      return easeBounceOut

    case 'easeBounceInOut':
      return easeBounceInOut

    default:
      return easeLinear
  }
}
